// src/holladai/pages/Dashboard.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { useOooData } from "../hooks/useOooData";
import { useInventoryStats } from "../hooks/useInventoryStats";
import "./Dashboard.css";

const HOTEL_IDS = [58404]; // hardcode for now

export default function Dashboard() {
  const navigate = useNavigate();

  // Out-of-Order Rooms
  const { data: oooData, loading: oooLoading, error: oooError } = useOooData(HOTEL_IDS);
  const portfolioOOOTotal = Object.values(oooData || {}).reduce(
    (acc, rooms) => acc + (rooms?.length || 0),
    0
  );

  // Inventory Statistics
  const { data: inventoryStats, loading: statsLoading, error: statsError } =
    useInventoryStats(HOTEL_IDS);

  // Portfolio totals
  const portfolioTotals = Object.values(inventoryStats || {}).reduce(
    (acc, stats) => {
      acc.occupancy += stats?.occupancy || 0;
      acc.arrivals += stats?.arrivals || 0;
      acc.departures += stats?.departures || 0;
      acc.stayOvers += stats?.stayOvers || 0;
      acc.totalReserved += stats?.totalReserved || 0;
      return acc;
    },
    { occupancy: 0, arrivals: 0, departures: 0, stayOvers: 0, totalReserved: 0 }
  );

  const loading = oooLoading || statsLoading;
  const error = oooError || statsError;

  // Define cards and the stat type to send to Portfolio
  const cards = [
    {
      label: "Total Out-of-Order Rooms",
      value: portfolioOOOTotal,
      statType: "oooRooms",
    },
    {
      label: "Portfolio Occupancy",
      value: portfolioTotals.occupancy,
      statType: "occupancy",
    },
    {
      label: "Arrivals",
      value: portfolioTotals.arrivals,
      statType: "arrivals",
    },
    {
      label: "Departures",
      value: portfolioTotals.departures,
      statType: "departures",
    },
    {
      label: "Stay Overs",
      value: portfolioTotals.stayOvers,
      statType: "stayOvers",
    },
    {
      label: "Total Rooms Reserved",
      value: portfolioTotals.totalReserved,
      statType: "totalReserved",
    },
  ];

  return (
    <div className="dashboard-container">
      <h1 className="dashboard-title">Extended Stay Portfolio Rollup</h1>

      {loading && <p>Loading OHIP data...</p>}
      {error && <p style={{ color: "red" }}>Error: {error}</p>}

      {!loading && !error && (
        <div className="stats-grid">
          {cards.map((card) => (
              <div
                key={card.statType} // ✅ Use statType as the unique key
                className="stat-card"
                onClick={() =>
                  navigate(`/holladai/portfolio?stat=${card.statType}`)
                }
              >
                <p className="stat-label">{card.label}</p>
                <p className="stat-value">{card.value}</p>
                <p className="stat-subtext">View details →</p>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
